<template>
    <div>
      <!-- modal -->
      <b-modal
        id="nationalTrademarkHistoryFormModal" centered size="lg" no-close-on-backdrop ref="nationalTrademarkHistoryFormModal" :title=" $t('nationalTrademarkHistory.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
              <b-col class="col-md-12 mt-1">
                <b-form-group>
                    <label for="national-rademark-history-date">{{ $t('nationalTrademarkHistory.date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-12">
                  <label for="national-trademark-history-status">{{ $t('nationalTrademarkHistory.status') }}</label>
                  <b-form>
                    <validation-provider :name="$t('nationalTrademarkHistory.status')" :rules="{ excluded: 0 }"
                      v-slot="{ errors }">
                      <b-form-select :state="errors.length > 0 ? false : null" v-model="nationalTrademarkHistoryStatusSelect" value-field="id"
                        text-field="name" :options="nationalTrademarkHistoryStatusOption" size="sm" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form>
              </b-col>
            </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>    
  export default {
    props: {
      getNationalTrademarkList: {type: Function},
      getNationalTrademarkHistoryList: {type: Function},
      getNationalTrademarkCountryList: {type: Function},
    },

    data() {
      return {
        id: 0,
        nationalTrademarkHistoryStatusSelect: 0,
        nationalTrademarkHistoryStatusOption: [],
        date: null,
        locale: this.$i18n.locale,
      }
    },
    methods: {
      showInfo(id, nationalTrademarkCountryId) {
        this.$refs['nationalTrademarkHistoryFormModal'].show()
        this.id = id
        this.nationalTrademarkCountryId = nationalTrademarkCountryId
        const data = { id: this.id, nationalTrademarkCountryId: this.nationalTrademarkCountryId }
        const controller = { name: 'NationalTrademarkHistory' }
        const payload = { data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
          if (response.data.resultStatus == true) {
            var newDate = response.data.nationalTrademarkHistory.date.split('T', -1)
            this.nationalTrademarkHistoryStatusSelect = response.data.nationalTrademarkHistory.nationalTrademarkStatusId
            this.nationalTrademarkHistoryStatusOption = response.data.nationalTrademarkStatusList
            this.date = response.data.nationalTrademarkHistory.date
            this.nationalTrademarkHistoryStatusOption.splice(0, 0, this.$nullSelected())
          } else {
            this.$bvModal.hide('nationalTrademarkHistoryFormModal')
            this.$WarningAlert(response.data.resultMessage)
          }
      })
        },
      addOrUpdate() {
        const data = {id: this.id, nationalTrademarkCountryId: this.nationalTrademarkCountryId, nationalTrademarkStatusId: this.nationalTrademarkHistoryStatusSelect, employeeId: localStorage.getItem('EmployeeId'), date: this.date}
        const controller = {name : 'NationalTrademarkHistory'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save',payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('nationalTrademarkHistoryFormModal')
                    this.getNationalTrademarkHistoryList()
                    this.getNationalTrademarkCountryList()
                    this.getNationalTrademarkList()
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  .btn-group, .btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    height: 2.7em;
}
[dir] .btn-secondary {
  border: 1px solid #7367f0 !important;
  background-color: transparent !important;
}
.datepickerStyle{
  max-height: 2.2em;
  font-family: fangsong;
}
  </style>